export const VAT_UAE = 0.05;
export const VAT_UAE_RECIPROCAL = 1.05;